import type { EChartsOption, MarkAreaComponentOption, MarkLineComponentOption } from 'echarts'
import { buildChartGrid, buildDataZoom, buildTimeXAxis, buildValueYAxis, formatTimeTooltip, type ChartDataZoom } from './base-chart-options'

export const TEMPERATURE_SERIES_COLOR = '#0d9488'

export interface BuildTemperatureChartOptionParams {
  chartData: [number, number][]
  dataZoom: ChartDataZoom
  /** markArea de alarme (período único ou períodos com hover). */
  markArea?: MarkAreaComponentOption
  /** markLine de limites do alarme. */
  markLine?: MarkLineComponentOption
  /** markLine de setpoint crítico (linha guia). */
  setpointMarkLine?: MarkLineComponentOption
  showLegend?: boolean
  showSeriesName?: boolean
  connectNulls?: boolean
  gridTop?: string
  gridLeft?: string
  gridRight?: string
  sliderBottom?: number
  showMoveHandle?: boolean
}

/** Opções ECharts para gráfico de temperatura (série única em teal). */
export function buildTemperatureChartOption(params: BuildTemperatureChartOptionParams): EChartsOption {
  const {
    chartData,
    dataZoom,
    markArea,
    markLine,
    setpointMarkLine,
    showLegend = false,
    showSeriesName = true,
    connectNulls = true,
    gridTop,
    gridLeft,
    gridRight,
    sliderBottom = 8,
    showMoveHandle = false,
  } = params

  return {
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross' },
      formatter: (params: any) => {
        const arr = Array.isArray(params) ? params : [params]
        const p = arr[0]
        if (p?.value?.[1] == null) return ''
        const timeStr = formatTimeTooltip(p.value[0])
        const value = Number(p.value[1]).toFixed(1)
        return showSeriesName ? `${timeStr}<br/>Temperatura: <strong>${value} °C</strong>` : `${timeStr}<br/><strong>${value} °C</strong>`
      },
    },
    legend: showLegend
      ? {
          data: ['Temperatura'],
          top: 0,
          left: 0,
          right: 0,
          textStyle: { fontSize: 10 },
        }
      : undefined,
    grid: buildChartGrid({ top: gridTop, left: gridLeft, right: gridRight }),
    dataZoom: buildDataZoom({
      dataZoom,
      accentColor: TEMPERATURE_SERIES_COLOR,
      fillerColor: 'rgba(13, 148, 136, 0.2)',
      sliderBottom,
      showMoveHandle,
    }),
    xAxis: buildTimeXAxis(),
    yAxis: buildValueYAxis({ unit: '°C' }),
    series: [
      {
        name: 'Temperatura',
        type: 'line',
        smooth: false,
        connectNulls,
        data: chartData,
        symbol: 'none',
        symbolSize: 0,
        lineStyle: { width: 2, color: TEMPERATURE_SERIES_COLOR },
        itemStyle: { color: TEMPERATURE_SERIES_COLOR },
        markLine: markLine ?? setpointMarkLine,
        markArea,
      },
    ],
  }
}
